export default function addActiveClass ($targetClassName, $className = 'active') {
  const $targetEl = document.querySelector(`.${$targetClassName}`);
  if ($targetEl) {
    $targetEl.classList.add($className);
  }
}
